export var filterWithoutFakeColumns = function (_a) {
    var _b = _a.props, isToggleColumn = _b.isToggleColumn, isSelectionColumn = _b.isSelectionColumn;
    return !isToggleColumn && !isSelectionColumn;
};
//# sourceMappingURL=filterWithoutFakeColumns.js.map